import { default as BottomPart } from './BottomPart'
import { default as HalvesInfo } from './HalvesInfo'
import { default as HalvesHeader } from './HalvesHeader'
import { default as HorizontalRanking } from './HorizontalRanking'
import { default as LeftHalf } from './LeftHalf'
import { default as LiveStatusTitle } from './LiveStatusTitle'
import { default as MiddleInfo } from './MiddleInfo'
import { default as RightHalf } from './RightHalf'
import { default as Score } from './Score'
import { default as SportsExtraContentWrapper } from './SportsExtraContentWrapper'
import { default as SportsHeaderWrapper } from './SportsHeaderWrapper'
import { default as StatusTitle } from './StatusTitle'
import { default as StatusTitleWrapper } from './StatusTitleWrapper'
import { default as TeamLogo } from './TeamLogo'
import { default as TeamName } from './TeamName'
import { default as TennisScoreTable } from './TennisScoreTable'
import { default as TopBottomHeader } from './TopBottomHeader'
import { default as TopPart } from './TopPart'
import { default as VerticalRanking } from './VerticalRanking'

const exports = {
  BottomPart,
  HalvesInfo,
  HalvesHeader,
  HorizontalRanking,
  LeftHalf,
  LiveStatusTitle,
  MiddleInfo,
  RightHalf,
  Score,
  SportsExtraContentWrapper,
  SportsHeaderWrapper,
  StatusTitle,
  StatusTitleWrapper,
  TeamLogo,
  TeamName,
  TennisScoreTable,
  TopBottomHeader,
  TopPart,
  VerticalRanking,
}

export default exports
